/* @flow */

import React from 'react';
import Relay from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { compose, pure } from 'recompose';
import { css } from 'glamor';

import ShopLink from 'depop/apps/shops/links/ShopLink';

import Link from 'depop/components/Link';
import LogoutButton from './LogoutButton';

type Props = {
  user: Object,
  showSearch: () => void,
  toggleSearch: () => void,
  toggleFullPageNav: () => void,
  searchExpanded: () => void,
};

const UserMenu = ({user, showSearch, toggleSearch, toggleFullPageNav, searchExpanded}: Props) => {
  return (
    <div {...css({
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      zIndex: '10',
    })}>
      {showSearch && !searchExpanded && <a
        {...css({
          display: 'none',
          '@media (min-width: 701px)': {
            display: 'inline',
          },
          marginLeft: '1em',
          fontWeight: 'bold',
          color: 'inherit',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
        })}
        href="javascript:;"
        onClick={toggleSearch}>
        <FormattedMessage
          id="app.searchLabel"
          description="Search Label"
          defaultMessage="Search"
        />
      </a>}
      <Link to="/search"
        {...css({
          display: 'inline',
          '@media (min-width: 701px)': {
            display: 'none',
          },
          marginLeft: '1em',
          fontWeight: 'bold',
          color: 'inherit',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
        })}>
      Search</Link>
      <ShopLink user={user} {...css({
        display: 'none',
        '@media (min-width: 701px)': {
          display: 'inline',
        },
        marginLeft: '1em',
        fontWeight: 'bold',
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline',
        },
      })}>
        <FormattedMessage
          id="app.profileLabel"
          description="Profile Label"
          defaultMessage="Profile"
        />
      </ShopLink>
      <a
        {...css({
          display: searchExpanded ? 'none' : 'block',
          '@media (min-width: 701px)': {
            display: 'none',
          },
          marginLeft: '1em',
          color: 'inherit',
          fontWeight: 'bold',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
        })}
        href="javascript:;"
        onClick={toggleFullPageNav}>
        <FormattedMessage
          id="app.menuLabel"
          description="Menu Label"
          defaultMessage="Menu"
        />
      </a>
      <span
        {...css({
          display: 'none',
          '@media (min-width: 701px)': {
            display: 'inline',
          },
          marginLeft: '1em',
          fontWeight: 'bold',
          color: 'inherit',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
        })}>
        <LogoutButton />
      </span>
    </div>
  );
};

const enhance = compose(
  pure,
);

export default Relay.createContainer(enhance(UserMenu), {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${ShopLink.getFragment('user')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/components/UserMenu.js